module.exports = __webpack_public_path__ + "static/media/Header_Image_002.54a75812.png";